import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLinkedin,
  faGithub,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <a
            href="https://www.linkedin.com/in/freddyclavijo/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FontAwesomeIcon icon={faLinkedin as IconProp} />
          </a>
          <a
            href="https://github.com/fredcoder"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FontAwesomeIcon icon={faGithub as IconProp} />
          </a>
          <a
            href="https://www.instagram.com/fredcoder/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FontAwesomeIcon icon={faInstagram as IconProp} />
          </a>
        </div>

        <p className="footer-copy">
          &copy; {year} <span>Freddy Clavijo</span>. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer
